export function getChampionshipReleaseTimestamp(championship) {
  if (!championship?.releaseDateTime) return null

  const timestamp = new Date(championship.releaseDateTime).getTime()
  return Number.isNaN(timestamp) ? null : timestamp
}

export function getChampionshipPublishingStatus(championship, now = new Date()) {
  if (!championship?.reviewedTs) return 'draft'

  const releaseTimestamp = getChampionshipReleaseTimestamp(championship)
  if (!releaseTimestamp) return 'released'

  const nowTimestamp =
    now instanceof Date ? now.getTime() : new Date(now).getTime()
  return releaseTimestamp > nowTimestamp ? 'scheduled' : 'released'
}

export function isChampionshipReleased(championship, now = new Date()) {
  return getChampionshipPublishingStatus(championship, now) === 'released'
}

export function isChampionshipScheduled(championship, now = new Date()) {
  return getChampionshipPublishingStatus(championship, now) === 'scheduled'
}
